const ACTIVE = 'active'
const REP = 'rep'

async function clearLocalStorage() {
  localStorage.removeItem(ACTIVE);
  localStorage.removeItem(REP);
}

export {clearLocalStorage}
